import recaptcha from "./recaptcha";
import { 
  ValidateAddress,
  ValidateEmail,
  ValidateLogin,
  ValidateCity,
  ValidateName,
  ValidatePassword,
  ValidatePasswordRepeat,
  ValidatePhone,
  ValidatePostalCode,
  ValidateSecondName
} from "../validators/indexValidator";
import '../../libraries/jquery.inputmask.min';

export default function account() {
  recaptcha();
  $(function () {
    initRegistrationValidators();
    initLogin();
    $("#ucRegistration_divLand_selector").on("change", RegistrationFormCountrySelectorHandler)
    $("#ucRegistration_divLand_selector").trigger("change")

    $("#registerUserFormButton").on("click", async function (event) {
      event.preventDefault();
      await RegisterUser();
    })

    $(document).on('click', function (e) {
      if ($(e.target).hasClass('change-password')) {
        RememberPassword(e.target);
      }
      if ($(e.target).hasClass('registerCatalogUser')) {
        RefreshCatalogUser();
      }
      if ($(e.target).hasClass('cancelCatalogUser')) {
        CancelCatalogUser();
      }
    })
  })

  function initLogin() {
    $(".login-controls input[type='text'], input[type='password']").on("keyup", function (event) {
      if (event.which == 13) {
        event.preventDefault();
        event.stopPropagation()
        ValidateLogin($("#btnLogin"));
      }
    });
  }

  function checkRegistrationNumber(source, argument, isUniqueCheck) {
    if ($("#forgotpassword-popup").length > 0 && $("#forgotpassword-popup").is(":visible")) {
      argument.IsValid = false;
      return;
    }

    var field = $(source).parent().find('input[type="text"]');
    var selectedCountryOption = $('#ucRegistration_divLand_selector').find("option:selected");
    var error;

    var isValid = false;

    UnblockForm();

    if (field.val() == '') {
      isValid = true;
    }
    else {
      var obj = {};
      obj.RegNumber = field.val();
      obj.IsUniqueCheck = isUniqueCheck;
      obj.SelectedCountryId = selectedCountryOption.val();
      $.ajax({
        data: JSON.stringify(obj),
        async: false,
        contentType: "application/json",
        type: "POST",
        url: "/api/account/CheckRegNumber",
        beforeSend: function () {

        },
        success: function (data) {
          if (data != null) {
            if (data.IsSuccess) {
              field.removeClass('error');

              isValid = true;
              error = '';
            }
            else {
              error = data.Message;
              isValid = false;
              field.addClass('error');

              if (!data.IsUnique && isUniqueCheck == true && $("#catalogReg").length == 0) {
                BlockForm();
              }
            }
          }
        }
      });

    }

    $(source).text(error);
    argument.IsValid = isValid;
  }

  function BlockForm() {
    $(".tbxName").attr("disabled", "disabled");
    $(".tbxSecondName").attr("disabled", "disabled");
    $("input.tbxLogin").attr("disabled", "disabled");
    $("input.tbxEmail").attr("disabled", "disabled");
    $("input.tbxMobile").attr("disabled", "disabled");
    $("input.tbxPhone").attr("disabled", "disabled");
    $("input.tbxPass").attr("disabled", "disabled");
    $("input.tbxPassRepeat").attr("disabled", "disabled");
    $("input.tbxCO").attr("disabled", "disabled");
    $("input.tbxAddress").attr("disabled", "disabled");
    $("input.tbxPostNumber").attr("disabled", "disabled");
    $("input.tbxCity").attr("disabled", "disabled");
    $("input#chkCatalogue").attr("disabled", "disabled");
    $("input#chkNews").attr("disabled", "disabled");
  }

  function UnblockForm() {
    $(".tbxName").removeAttr("disabled");
    $(".tbxSecondName").removeAttr("disabled");
    $("input.tbxLogin").removeAttr("disabled");
    $("input.tbxEmail").removeAttr("disabled");
    $("input.tbxMobile").removeAttr("disabled");
    $("input.tbxPhone").removeAttr("disabled");
    $("input.tbxPass").removeAttr("disabled");
    $("input.tbxPassRepeat").removeAttr("disabled");
    $("input.tbxCO").removeAttr("disabled");
    $("input.tbxAddress").removeAttr("disabled");
    $("input.tbxPostNumber").removeAttr("disabled");
    $("input.tbxCity").removeAttr("disabled");
    $("input#chkCatalogue").removeAttr("disabled");
    $("input#chkNews").removeAttr("disabled");
  }

  function validateUserAlias(source, args) {
    var alias = args.Value;
    var valid = true;
    var chars = new RegExp(/^[A-zäöåÄÖÅ0-9_-]+$/i);

    if (alias.length < 1) {
      valid = false;
    }
    if (!alias.match(chars)) {
      valid = false;
      $(source).html("Ogiltiga tecken");
    }
    if (valid) {
      $.ajax({
        type: "POST",
        url: "/api/account/CheckLoginInfo",
        async: false,
        data: JSON.stringify(args.Value),
        contentType: "application/json",
        success: function (data) {
          if (data != null) {
            valid = data.IsSuccess;
          }
        }
      });
    }

    args.IsValid = valid;
  }

  function initRegistrationValidators() {
    $("#pnlRegistrationForm input.tbxName, #payment-container input.tbxName").on('blur', function () {
      ValidateName($(this));
    });
    $("#payment-container input.tbxCompanyName").on('blur', function () {
      ValidateCompanyName($(this));
    });
    $("#pnlRegistrationForm input.tbxSecondName, #payment-container input.tbxSecondName").on('blur', function () {
      ValidateSecondName($(this));
    });
    $("#pnlRegistrationForm input.tbxPersonNumber, #payment-container input.tbxPersonNumber").on('blur', async function () {
      await ValidatePersonNumber($(this));
    });
    $("#pnlRegistrationForm input.tbxLogin, #payment-container input.tbxLogin").on('blur', function () {
      ValidateLoginReg($(this));
    });
    $("#pnlRegistrationForm input.tbxEmail, #payment-container input.tbxEmail").on('blur', function () {
      ValidateEmail($(this), null, null, null, $(this).parent().siblings(".registration-number").find("input"));
    });
    $("#pnlRegistrationForm input.tbxMobile, #payment-container input.tbxMobile").on('blur', function () {
      ValidatePhone($(this));
    });
    $("#payment-container input.tbxAddress").on('blur', function () {
      ValidateAddress($(this));
    });
    $("#payment-container input.tbxCity").on('blur', function () {
      ValidateCity($(this));
    });
    $("#payment-container input.tbxPostalCode").on('blur', function () {
      ValidatePostalCode($(this));
    });
    $("#payment-container select.m_country").on('blur', function () {
      ValidateCountry($(this));
    });
    $("#pnlRegistrationForm input.tbxPass").on('blur', function () {
      ValidatePassword();
      ValidatePasswordRepeat();
    });
    $("#pnlRegistrationForm input.tbxPassRepeat").on('blur', function () {
      ValidatePassword($(this));
      ValidatePasswordRepeat();
    });
  }

  function ValidateCompanyName(CompanyName) {
    var valid = true;
    var rfvCompanyName = CompanyName.siblings("#CompanyRequired");
    rfvCompanyName.hide();

    CompanyName.removeClass("error");
    if ($.trim(CompanyName.val()).length == 0) {
      valid = false;
      rfvCompanyName.show();
      CompanyName.addClass("error");
    }
    return valid;

  }

  function ValidateCountry(Country) {
    var valid = true;

    var rfvCountry = Country.siblings("#CountryRequired");
    rfvCountry.hide();
    Country.removeClass("error");
    if (Country.val().length == 0) {
      valid = false;
      rfvCountry.show();
      Country.addClass("error");
    }
    return valid;
  }

  async function ValidatePersonNumber(PersonNumber) {
    var valid = true;
    
    var selectedOption = $("#ucRegistration_divLand_selector").find("option:selected");
    var snIsRequired = $(selectedOption).data("sn-required");
    if (snIsRequired !== "True")
      return valid;

    var cvPersonNumber = PersonNumber.siblings("#cvPersonNumber");

    cvPersonNumber.hide();
    PersonNumber.removeClass("error");

    var isPersonNumberValid = {};
    checkRegistrationNumber(cvPersonNumber, isPersonNumberValid, $("#catalogReg").length == 0);
    if (!isPersonNumberValid.IsValid) {
        valid = false;
        cvPersonNumber.show();
        PersonNumber.addClass("error");
    }
    return valid;
  }

  function ValidateLoginReg(Login) {
    var valid = true;
    var rfvLogin = Login.siblings("#rfvLogin");
    var cvLogin = Login.siblings("#cvLogin");

    rfvLogin.hide();
    cvLogin.hide();
    Login.removeClass("error");
    if (Login.val().length == 0) {
      valid = false;
      rfvLogin.show();
      Login.addClass("error");
    }
    else {
      var isLoginValid = {};
      isLoginValid.Value = Login.val();
      validateUserAlias("#cvLogin", isLoginValid);
      if (!isLoginValid.IsValid) {
        valid = false;
        cvLogin.show();
        Login.addClass("error");
      }
    }
    return valid;
  }

  async function RegisterUser() {
    var isCatalog = $(".catalog-reg").length > 0;
    if (isCatalog && $("#registration-dialog").is(":visible")) {
      isCatalog = false;
    }
    if (isCatalog) {
      $(".order-catalog-text .errorMessage").hide();
    }
    var containerName = isCatalog ? ".catalog-reg" : "#pnlRegistrationForm";
    var methodName = isCatalog ? "RegisterCatalogUser" : "RegisterUser";
    var valid = true;
    var Name = $(containerName + " input.tbxName");
    var SecondName = $(containerName + " input.tbxSecondName");
    var PersonNumber = isCatalog ? $(containerName + " input.tbxPersonNumber") : $(containerName + " input.tbxPersonNumber").not(".catalog-reg input.tbxPersonNumber");
    var Login = $(containerName + " input.tbxLogin");
    var Email = $(containerName + " input.tbxEmail");
    var Phone = $(containerName + " input.func-phone");
    var Password = $(containerName + " input.tbxPass");
    var PasswordRepeat = $(containerName + " input.tbxPassRepeat");
    var Address = $(containerName + " input.tbxAddress");
    var PostNumber = $(containerName + " input.tbxPostNumber");
    var City = $(containerName + " input.tbxCity");
    var validArr = [];
    validArr.push(ValidateName(Name));
    validArr.push(ValidateSecondName(SecondName));
    validArr.push(await ValidatePersonNumber(PersonNumber));
    validArr.push(ValidateEmail(Email, null, null, null, PersonNumber));
    if (!isCatalog) {
      validArr.push(ValidatePhone(Phone));
      validArr.push(ValidateLoginReg(Login));
      validArr.push(ValidatePassword());
      validArr.push(ValidatePasswordRepeat());
    }
    else {
      validArr.push(ValidateAddress(Address));
      validArr.push(ValidatePostalCode(PostNumber));
      validArr.push(ValidateCity(City));
    }

    for (var i = 0; i < validArr.length; i++) {
      if (!validArr[i]) {
        valid = false;
        break;
      }
    }

    if (valid) {
      var obj = {};
      obj.FirstName = Name.val();
      obj.LastName = SecondName.val();
      obj.PersonNumber = PersonNumber.val();
      obj.UserName = Login.val();
      obj.Password = Password.val();
      obj.RepeatPassword = PasswordRepeat.val();
      obj.Mobile = Phone.val();
      obj.Email = Email.val();
      obj.CO = $(containerName + " input.tbxCO").val();
      obj.Address = Address.val();
      obj.Zip = PostNumber.val();
      obj.City = City.val();
      obj.CountryId = isCatalog ? 0 : $(containerName + " select.ddlCountry").val();
      obj.CountryText = $(containerName + " select.ddlCountry option:selected").text();
      obj.SubscribeToCatalog = isCatalog ? false : $("input#chkCatalogue").is(':checked');
      obj.SubscribeToNews = isCatalog ? false : $("input#chkNews").is(':checked');
      $.ajax({
        data: JSON.stringify(obj),
        async: true,
        contentType: "application/json",
        type: "POST",
        url: "/api/account/" + methodName,
        beforeSend: function () { $("#ucRegistraion_lnkbSubmit").addClass("show-loader") },
        complete: function () { $("#ucRegistraion_lnkbSubmit").removeClass("show-loader") },
        success: function (data) {
          if (data != null) {
            if (isCatalog) {
              if (data.IsSuccess) {
                if (typeof (fbq) != 'undefined') { fbq('track', 'CompleteRegistration'); }
                $(".order-catalog-text .successMessage").show();
                $(".catalog-reg").hide();
              } else {
                $(".order-catalog-text .errorMessage").show();
              }
            } else {
              var errorBlock = $('.func-registration-error');
              errorBlock.empty();

              if (data.IsSuccess) {
                if (data.RedirectUrl) {
                  window.location.href = addParameterToURL(data.RedirectUrl, "completeRegistrationEvent=true");
                  return;
                }
              } else {
                errorBlock.html(data.Message);
              }
            }
          }
        }
      });
    }
    return false;
  }

  function RememberPassword(target) {
    var hasError = false;

    var $rememberEmailEl = $("#remember-email");
    var $sendingResult = $("#sending-result");
    const $forgotPasswordMailContent = $("#forgot-password-main-content");
    const $forgotPasswordEmailSentContent = $("#forgot-password-email-sent-content");
    const $forgotPasswordReCaptcha = $("#forgotPasswordReCaptcha");

    var widgetId = window.ForgotPasswordRecaptchaId;

    if ($('.registration-page #remember-email').length && !$("#new-password-form #remember-email").is(":visible")) {
      $rememberEmailEl = $('.registration-page #remember-email');
      $sendingResult = $('.registration-page #sending-result');

      widgetId = window.ForgotPasswordRecaptchaPageId;
    }

    var emailaddressVal = $rememberEmailEl.val();

    if (emailaddressVal == '') {
      hasError = true;
      $rememberEmailEl.addClass('error');
    }
    else {
      $rememberEmailEl.removeClass('error')
    }

    var captchaResult = grecaptcha.getResponse(widgetId);
    if (captchaResult.length == 0) {
      hasError = true;
      $sendingResult.fadeIn().html("Captcha är fel");
    }
    else {
      $sendingResult.hide();
    }

    if (!hasError) {

      $.ajax({
        data: JSON.stringify({ Email: emailaddressVal, ReCaptcha: captchaResult }),
        contentType: "application/json",
        type: "POST",
        url: "/api/account/forgotpassword",
        beforeSend: function () {
          $(target).addClass("btn-disabled")
          $rememberEmailEl.attr("disabled", "disabled");
          
          $forgotPasswordMailContent.css("color", "gray");
          $forgotPasswordReCaptcha.css("display", "none");
        },
        success: function (data, status, xhr) {
          if (data.IsSuccess) {
            $forgotPasswordMailContent.css("display", "none");
            $forgotPasswordEmailSentContent.css("display", "block");
          }
          else {
            $rememberEmailEl.addClass('error');
            $sendingResult.fadeIn().html(data.Message);
            $(target).removeClass("btn-disabled")
            $forgotPasswordReCaptcha.css("display", "block");
            $rememberEmailEl.attr("disabled", null);
            $forgotPasswordMailContent.css("color", null);
          }
        },
        complete: function () {
          grecaptcha.reset(widgetId);
        },
      });
    }
  }

  function CancelCatalogUser() {
    UpdateCatalogSubscription(false,
      function (data) {
        if (data != null) {
          if (data.IsSuccess) {
            $(".order-catalog-text .cancelSuccess").show();
            $(".cancelCatalogUser").hide();
          } else {
            $(".order-catalog-text .cancelError").show();
          }
        }
      });
  }

  function RefreshCatalogUser() //for registered user
  {
    UpdateCatalogSubscription(true,
      function (data) {
        if (data != null) {
          if (data.IsSuccess) {
            $(".order-catalog-text .successMessage").show();
            $(".registerCatalogUser").hide();

          } else {
            $(".order-catalog-text .errorMessage").show();
          }
        }
      });
  }

  function UpdateCatalogSubscription(subscribe, onSuccess) {
    $.ajax({
      data: JSON.stringify(subscribe),
      async: false,
      contentType: "application/json",
      type: "POST",
      url: "/api/OrderCatalog/UpdateSubscription",
      beforeSend: function () { $('.registration-number .visa-loader').addClass('display-inline-block'); },
      success: onSuccess
    });
  }

  async function RegistrationFormCountrySelectorHandler() {
    var selectedOption = $("#registration-dialog").find("option:selected");
    var snRequired = $(selectedOption).data("sn-required");
    var countryCode = $(selectedOption).data("country-code");
    
    let regNumberInputHtmlElement = $("#ucRegistration_liRegNumber_input");
    regNumberInputHtmlElement.prop('disabled', snRequired !== "True")
    if (snRequired !== "True") {
      regNumberInputHtmlElement
        .val("")
        .prop('disabled', true)
        .removeClass('error');
      $('#cvPersonNumber').hide();
      UnblockForm();
    } else {
      setInputMask(regNumberInputHtmlElement, countryCode);
      if (regNumberInputHtmlElement.val()) {
        await ValidatePersonNumber(regNumberInputHtmlElement);
      } else {
        regNumberInputHtmlElement.removeClass('error');
        $('#cvPersonNumber').hide();
      }
    }
  }
  
  /**
   * Setting input mask for "Personal Number" for a particular country
   * @param {JQuery | HTMLElement | any} element <input> element
   * @param {string} countryCode Country ISO code
   */
  function setInputMask(element, countryCode) {
    const swedenPnRegex = "[0-9]{6}-[0-9]{4}"
    const finlandPnRegex = "[0-9]{6}[\-\+A][0-9]{3}[0-9A-Z]"
    
    switch (countryCode) {
      case "SE" :
        element.inputmask({regex : swedenPnRegex});
        break;
      case "FI":
        element.inputmask({regex : finlandPnRegex});
    }
  }
  
  function addParameterToURL(url, param) {
    let _url = url;
    _url += (_url.split('?')[1] ? '&' : '?') + param;
    return _url;
  }
}
